import { getTournamentOverviewStatsRest } from '@/services/tournaments/tournaments-service';
import { useQuery } from '@tanstack/react-query';

const useTournamentOverviewStats = (
  fromDate?: string,
  toDate?: string,
  {
    sng = false,
  }: {
    sng?: boolean;
  } = {},
) => {
  const { data: tournamentOverview } = useQuery({
    queryKey: ['tournamentOverview', fromDate, toDate, sng],
    queryFn: () => getTournamentOverviewStatsRest(fromDate, toDate, sng),
  });

  return {
    ...tournamentOverview,
  };
};

export default useTournamentOverviewStats;
